import { DiscardProps } from '../../components/forms/FormikForm/types';

const discardChanges: DiscardProps = {
    discardButtonTitle: 'Discard changes',
    showCancelButton: false,
    locationOnDiscard: '/',
};

export default discardChanges;
